import { createRef } from 'react';
import { createSlice } from '../store';
import { setCanvasDimensions, setViewportRect } from './transformers';
import type { CameraSlice } from './types';

// ============================================================================
// Slice Factory
// ============================================================================

export const createCameraSlice = createSlice<
  Record<string, never>
>()<CameraSlice>(set => ({
  canvas: {
    transform: {
      translateX: 0,
      translateY: 0,
      zoom: 1,
    },
    viewportRect: {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
    },
    dimensions: {
      width: 0,
      height: 0,
    },
    padding: {
      top: 52,
      right: 100,
      bottom: 200,
      left: 100,
    },
    // Refs are created once at store init and mutated via React's ref mechanism,
    // not via set(). This makes the store non-serializable — acceptable since we
    // don't need devtools snapshot, persistence, or SSR for canvas state.
    refs: {
      viewportRef: createRef(),
      canvasRef: createRef(),
      contentRef: createRef(),
      overlayRef: createRef(),
      containerRef: createRef(),
    },

    actions: {
      setViewportRect: rect => set(setViewportRect(rect)),
      setCanvasDimensions: dim => set(setCanvasDimensions(dim)),
    },
  },
}));
